/***
 * Created on 2024/11/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalComponent from "../../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import {get_primary_email} from "../../../service/common";
import {useRegion} from "../../../context/RegionContext";
import {useQueryClient} from "@tanstack/react-query";

function DeviceTransferToQidSuccess({openModal, closeModal, dispatch, state}) {
    const { t } = useTranslation();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const email = get_primary_email(currentUser);
    const {url} = useRegion();
    const queryClient = useQueryClient();

    const onSubmit = () => {
        window.location.href = url.get_myqnapcloud_fe_url();
    }

    const onClose = () => {
        queryClient.invalidateQueries(['/v1.2/device']).finally(() => {
            closeModal();
        });
    }

    return (
        <ModalComponent title={t('@Transfer Successful@')} isOpen={openModal} onClose={onClose} okText={t('@Visit myQNAPcloud@')} onSubmit={onSubmit}>
            <div className="dialog-content">
                <div className="text-wrap !mb-24">
                    {t('@Your device {{device_name}} has been successfully transferred from {{org_name}} to QID {{qid_email}}. Visit myQNAPcloud and sign in with this QID; the device should now be visible in "My Device."@',
                        {device_name: state?.device_data?.device_name, org_name: state?.organization?.name, qid_email: email})
                    }
                </div>
            </div>
        </ModalComponent>
    );
}

export default DeviceTransferToQidSuccess;